const PINCODE_REGEX = /^[1-9][0-9]{5}$/;

export function isValidPincode(pincode) {
  return PINCODE_REGEX.test((pincode || "").trim());
}

export async function lookupPincode(pincode) {
  const clean = (pincode || "").trim();
  if (!isValidPincode(clean)) return null;

  let json;
  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${clean}`);
    json = await res.json();
  } catch {
    return null;
  }

  const entry = Array.isArray(json) ? json[0] : null;
  if (!entry || entry.Status !== "Success" || !entry.PostOffice?.length) return null;
  return entry.PostOffice;
}
